import PropTypes from 'prop-types';
import React from 'react';
import { getCategories } from '@wix/communities-blog-client-common';
import { connect } from '../runtime-context';
import Header from '../header';

const CategoryMobileHeader = ({ categories, menu, ...otherProps }) =>
  categories.length ? (
    <Header menu={menu} {...otherProps} />
  ) : (
    <Header {...otherProps} />
  );

CategoryMobileHeader.propTypes = {
  categories: PropTypes.array,
  menu: PropTypes.node,
};

const mapStateToProps = (state) => ({
  categories: getCategories(state),
});

export default connect(mapStateToProps)(CategoryMobileHeader);
